<h4 mat-dialog-title>Select a Week</h4>
<mat-dialog-content>
  <mat-form-field>
    <mat-select placeholder = "Week" [(value)]="selectedWeek">
      <mat-option *ngFor="let week of weeks" [value]="week">
        {{formatWeek(week)}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <div fxFlex></div>
  <button mat-raised-button color="primary" [disabled]="!selectedWeek" (click)="close()">
    {{buttonLabel}}
  </button>
  <button mat-raised-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>